module.exports = __webpack_public_path__ + "static/img/retail_img_2_en.bfdcea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_svg/retail_img_2_en.png
// module id = Y7TZ
// module chunks = 0